import { FC, useLayoutEffect } from 'react'
import App from '../App'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import NotFoundPage from '../pages/404'
import { LayoutGeneral } from '../layout/LayoutGeneral'
import { AuthLayout } from '../layout/AuthLayout'
import ProfileRoutes from './app/ProfileRoutes'
import ProfilesPage from '../pages/ProfilesPage'
import { Login } from '../pages/auth/Login'
import { ResetPassword } from '../pages/auth/ResetPassword'
import { ForgotPassword } from '../pages/auth/ForgotPassword'
import { LayoutLogged } from '../layout/LayoutLogged'
import { LayoutConnect } from '../layout/LayoutConnect'
import InstagramRedirect from '../modules/authorization-modal/views/InstagramRedirect'
import LegalRoutes from './app/LegalRoutes'
import SettingsRoutes from './app/SettingsRoutes'
import OnboardingRoutes from './OnboardingRoutes'
import { LayoutNotLogged } from '../layout/LayoutNotLogged'

const AppRoutes: FC = () => {
  const location = useLocation()

  useLayoutEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <Routes>
      <Route element={<App />}>
        <Route element={<LayoutLogged />}>
          <Route path="/profiles/*" element={<ProfileRoutes />} />
          <Route element={<LayoutGeneral />}>
            <Route path="/profiles" element={<ProfilesPage />} />
            <Route path="/settings/*" element={<SettingsRoutes />} />
          </Route>
        </Route>

        <Route element={<LayoutNotLogged />}>
          <Route path="/auth" element={<AuthLayout />}>
            <Route path="login" element={<Login />} />
            <Route
              path="register"
              element={<Navigate to="/onboarding/registration" />}
            />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="forgot-password" element={<ForgotPassword />} />

            <Route index path="*" element={<Navigate to="/auth/login" />} />
          </Route>
        </Route>

        {/* ONBOARDINGS */}
        <Route path="/onboarding/*" element={<OnboardingRoutes />} />

        {/* LEGAL */}
        <Route path="/legal/*" element={<LegalRoutes />} />

        {/* FALLBACKS */}
        <Route path="*" element={<Navigate to="/profiles" />} />
        <Route index element={<Navigate to="/profiles" />} />
      </Route>

      {/* CONNECT CALLBACK */}
      <Route path="/profiles/connect" element={<LayoutConnect />}>
        <Route path="instagram-redirect" element={<InstagramRedirect />} />
      </Route>
    </Routes>
  )
}

export { AppRoutes }
